/**
 * @flow
 * @relayHash 94d138923518f301b94c2d588e2be779
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
export type currency_MutationVariables = {|
  input: {
    currency: Currency,
    clientMutationId?: ?string,
  },
|};
export type currency_MutationResponse = {|
  +changeCurrency: ?{|
    +viewer: ?{|
      +id: string,
      +selected_currency: ?Currency,
    |},
  |},
|};
*/


/*
mutation currency_Mutation(
  $input: ChangeCurrencyInput!
) {
  changeCurrency(input: $input) {
    viewer {
      id
      selected_currency
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ChangeCurrencyInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "changeCurrency",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ChangeCurrencyInput!"
      }
    ],
    "concreteType": "ChangeCurrencyPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "selected_currency",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "currency_Mutation",
  "id": null,
  "text": "mutation currency_Mutation(\n  $input: ChangeCurrencyInput!\n) {\n  changeCurrency(input: $input) {\n    viewer {\n      id\n      selected_currency\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "currency_Mutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "currency_Mutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
(node/*: any*/).hash = '5635c0b9d43dedabdd1c9ed994faff58';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/currency_Mutation.graphql.js